
import React from "react";

const TableBody = ({
  rows,
  columns,
  editingCell,
  editValue,
  selectedRange,
  onCellMouseDown,
  onCellMouseEnter,
  onCellDoubleClick,
  onContextMenu,
  setEditValue,
  finishEditing,
  formatValue,
  shouldBeBold
}) => {
  // Handle click to close context menu
  const handleCellClick = (e) => {
    // If it's a left click, allow normal behavior
    // Right clicks are handled by onContextMenu
    if (e.button === 0) {
      // Left click - normal behavior
    }
  };

  return rows.map((row, rowIndex) => {
    const isAlternateRow = rowIndex % 2 === 1;
    
    return (
      <tr 
        key={rowIndex}
        className={`${isAlternateRow ? 'bg-blue-50' : 'bg-white'}`}
        style={{
          backgroundColor: isAlternateRow ? '#f0f8ff' : '#ffffff'
        }}
      >
        {columns.map((col, colIndex) => {
          const editing =
            editingCell?.r === rowIndex &&
            editingCell?.c === col.id;

          const isBold = shouldBeBold(row[col.id], rowIndex, colIndex);
          const isFirstColumn = colIndex === 0;
          
          const isSelected = selectedRange && 
                            rowIndex >= selectedRange.startRow && 
                            rowIndex <= selectedRange.endRow &&
                            colIndex >= selectedRange.startCol && 
                            colIndex <= selectedRange.endCol;

          return (
            <td
              key={col.id}
              className={`excel-td ${isSelected ? 'selected-cell' : ''}`}
              onMouseDown={(e) => onCellMouseDown(rowIndex, col.id, e)}
              onMouseEnter={() => onCellMouseEnter(rowIndex, col.id)}
              onDoubleClick={() => onCellDoubleClick(rowIndex, col.id)}
              onContextMenu={(e) => onContextMenu(e, rowIndex, col.id)}
              onClick={handleCellClick}
              style={{
                textAlign: isFirstColumn ? 'left' : 'right',
                position: 'relative',
                fontWeight: isBold ? '600' : '400',
                color: isBold ? '#000' : '#333',
                backgroundColor: isSelected ? '#dbeafe' : (isAlternateRow ? '#f0f8ff' : '#ffffff'),
                minWidth: `${col.width || 120}px`,
                width: `${col.width || 120}px`,
                maxWidth: '500px'
              }}
            >
              {editing ? (
                <input
                  autoFocus
                  value={editValue}
                  onChange={e => setEditValue(e.target.value)}
                  onBlur={finishEditing}
                  onKeyDown={e => {
                    if (e.key === "Enter") finishEditing();
                    if (e.key === "Escape") finishEditing();
                  }}
                  className="excel-input"
                  style={{
                    textAlign: isFirstColumn ? 'left' : 'right',
                    fontWeight: 'inherit',
                    color: 'inherit',
                    width: '100%'
                  }}
                />
              ) : (
                <div 
                  className={`${isFirstColumn ? "excel-text" : "excel-number"}`}
                  style={{
                    fontWeight: 'inherit',
                    color: 'inherit',
                    textAlign: isFirstColumn ? 'left' : 'right',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%'
                  }}
                  title={row[col.id]}
                >
                  {formatValue(row[col.id], col.id, rowIndex)}
                </div>
              )}
            </td>
          );
        })}
      </tr>
    );
  });
};

export default TableBody;
